// extracted by mini-css-extract-plugin
export default {"hd":"SuccessStorySection_hd__z6btU","tx1":"SuccessStorySection_tx1__54PdV","hd1":"SuccessStorySection_hd1__bFLnY","tx2":"SuccessStorySection_tx2__vfXEK"};